import React, { useState ,useEffect } from "react";//, useEffect
import {
  Typography
} from "@material-ui/core";

import {
  useQuery,
  useMutation,
  useQueryClient,
} from 'react-query'
import { useParams } from 'react-router-dom'; 
import * as api from '../../../actions/api';
import DispenserFormData from './LMISForm2FormData.js';
 
import moment from "moment";

const AddLMISForm2 = (props) => {

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "lmisform2";
const FacilityId=localStorage.getItem('FacilityId');
  
const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState(''); 
const [countTotalUpazila, setTotalUpazila] = useState(0); 

let currentYear = new Date().getFullYear();
let currentMonthId = new Date().getMonth(); // 0,1,2,3,4,5........

//select previous month.
if(currentMonthId == 0){
  currentYear = currentYear-1;
  currentMonthId = 12;
}

const [selectedYearName, setSelectedYearName] = useState(currentYear); 
// console.log('selectedYearName: ', selectedYearName);
const [selectedMonthId, setSelectedMonthId] = useState(currentMonthId); 
// console.log('selectedMonthId: ', selectedMonthId);

  const [formData, setFormData] = useState({
      TransactionNo: generatedInvoiceNo, 
      TransactionDate: selectedDate,
      TransactionTypeId:0,
      "FacilityId":FacilityId,
      FacilityCode:FacilityId,
      // YearName:selectedYearName,
      // MonthId:selectedMonthId,
      Remarks:"",
      bUpdated:0,
      // RCondom:"", 
      // RShukhi:"", 
      // RIdu:"", 
      // RInjectable:"", 
      ReportedMonthId:selectedMonthId,
      UnionCode:"",
      ReportedYear:selectedYearName,
      TotalWorkers:"",
      ReportsSubmitted:"",
      ExistingbShow:"",
      UnionName:"",
      
  });

  const [ManyTableData, setManyTableData] = useState( []); 
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);

   
  
const handleRDateChange = (date, field) => {
  let newDate = moment(date).format("YYYY-MM-DD");
  setFormData({ ...formData, [field]: newDate });
  setErrorObject({ ...errorObject, [field]: null });
  api.dirtyModeEnable();
};

 const handleDateChange = (date) => {
  setSelectedDate(date);
}; 
 

  const [errorObject, setErrorObject] = useState({});
   
  const { id } = useParams();
  const queryClient = useQueryClient();

  let params={"menukey": "lmisform2", "FacilityId":FacilityId, "TransactionTypeId":0, TransactionDate: '', TableName: 'form2master'};
  const {  data:invoiceNo, refetch } = useQuery([params], api.getInvoiceNo, 
    {onSuccess: (data) => {
      
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["TransactionNo"] = data; 
      setFormData(fdata); 

    }}
    );

  // const { isLoading, mutate } = useMutation(api.saveLMISForm2, {
  //   onSuccess: (data) => { 
  //     if (data.status == 200) {

  //     props.openNoticeModal({
  //       isOpen: true,
  //       msg: data.message,
  //       msgtype: data.success,
  //     });

  //     let route = `edit/${data.TransactionId}`;
  //     props.history.push(route); 
      
  //     }else{
  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.message,
  //         msgtype: data.success,
  //       });
  //     }
  //   }
  // })  
  const handleAdd = (NonOrderProductData) => {
      setManyTableData(NonOrderProductData);
      setUpdatedDetailGridData(NonOrderProductData);
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('formData: ', e.target);

      let data = { ...formData };
      
      data[name] = value; 
      setFormData(data); 
    setErrorObject({ ...errorObject, [name]: null });
    api.dirtyModeEnable();
  };

  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    data[name] = value;   
    setFormData(data); 
    setErrorObject({ ...errorObject, [name]: "" });
    api.dirtyModeEnable();
  }
  //====== End Choosen Dropdown===========

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };



  const handleReset = () => {
    setFormData({
      TransactionNo: generatedInvoiceNo, 
      TransactionDate: selectedDate,
      TransactionTypeId:0,
      "FacilityId":FacilityId,
      FacilityCode:FacilityId,
      // YearName:selectedYearName,
      // MonthId:selectedMonthId,
      Remarks:"",
      bUpdated:0,
      // RCondom:"", 
      // RShukhi:"", 
      // RIdu:"", 
      // RInjectable:"", 
      ReportedMonthId:selectedMonthId,
      UnionCode:"",
      ReportedYear:selectedYearName,
      TotalWorkers:"",
      ReportsSubmitted:"",
      ExistingbShow:"",
      UnionName:"",
      ManyJsonSave: []
    });
    setManyTableData([]);
  };

  const validateForm = (formData) => {
    let validateFields = ["UnionCode","TransactionDate", "TransactionNo","ReportedYear","ReportedMonthId"]
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !']
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  // const handleSubmit = async (e) => {
  //   console.log("from submit ", 
    
  //   );
  //   if (validateForm(formData)) {
  //     let fDtat={...formData,'ManyJsonSave':ManyTableData,"menukey":"lmisform2"};
  //     mutate(fDtat);
      
  //   }
  // };
  const deleteReceiveInv=(data)=>{
    
    let newarray = ManyTableData.filter(element => element !== data); 
    setManyTableData(newarray);

  }

  // const setUpdatedDetailsGridDataHandler = (rows) => { 
  //   if (validateForm(formData)) {
  //     let fDtat={...formData,'ManyJsonSave':rows,"menukey":"lmisform2"}; 
  //     mutate(fDtat); 
  //     }

  //   setManyTableData(rows); 
  // };


  function checkValidateForm(rows, callfrom){

    if(callfrom == "edit"){
      setManyTableData(rows); 
    }

    // return validateForm(formData);
    if (validateForm(formData)) {
        let fDtat={...formData,'ManyJsonSave':rows,'deletedDataSet':[]}; 
        //mutateUpdate(fDtat); 
        return fDtat;
      }else{
        return false;
      }
  };
  
  useEffect(() => { 
  }, []); 



  return (
    <> 
      <DispenserFormData 
      errorObject={errorObject} 
      addProductForm={true} 
      formData={formData} 
      handleChange={handleChange} 
      handleChangeChoosenProps={handleChangeChoosenProps} 
      handleCheck={handleCheck} 
      handleReset={handleReset} 
      // invoiceCancel={invoiceCancel} 
      // handleSubmit={handleSubmit} 
      ManyTableData={updatedDetailGridData}   
      handleRDateChange={handleRDateChange} 
      selectedDate={selectedDate} 
      deleteReceiveInv={deleteReceiveInv}
      // setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
      bStockUpdate={props.permissionType}
      handleAdd={handleAdd} 
      generatedInvoiceNo={generatedInvoiceNo}
      selectedYearName={selectedYearName}
      checkValidateForm={checkValidateForm}

      {...props} />
      
      
    </>

    
  );
};

export default AddLMISForm2;